var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWritingIconinline = function SvgWritingIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    x: 5.5,
    y: 5.5,
    stroke: "#EE2B6C",
    strokeWidth: 3,
    rx: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4BEE",
    d: "M3.5 3.5h65v65h-65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2B4BEE",
    strokeWidth: 2,
    d: "M1 1h9v9H1zM62 1h9v9h-9zM1 62h9v9H1zM62 62h9v9h-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.686 44.947c-.46-1.713-1.763-5.905-4.178-9-.549-.705-.687-1.673-.247-2.45 5.224-9.218 6.896-12.14 7.431-13.067.138-.24.476-.43.752-.43l1.798.002v11.789c-1.322.346-2.299 1.567-2.299 3.02 0 1.722 1.372 3.118 3.065 3.118s3.064-1.396 3.064-3.118c0-1.453-.976-2.673-2.297-3.02V20.004l1.796.002c.276 0 .615.192.753.431.536.928 2.21 3.85 7.431 13.06.44.777.303 1.745-.246 2.45-2.415 3.096-3.717 7.287-4.177 9-.122.454-.53.777-1 .777H30.685c-.47 0-.877-.323-1-.777",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.584 50.323a3 3 0 0 1 3-3h10.854a3 3 0 0 1 3 3V51a1 1 0 0 1-1 1H28.584a1 1 0 0 1-1-1z"
  })));
};
export default SvgWritingIconinline;